/** Shared by every app on this origin: same key = signed in on `/` and on `/app/`. Never change it in one app. */
export const SUPABASE_STORAGE_KEY = 'sb-fryfcvxbdjikxsvdpnks-auth-token';
